import { defineMessages } from 'react-intl';

export default defineMessages({
  labelSearchHealth: {
    id: 'Search articles, news, diseases...',
    defaultMessage: 'Search articles, news, diseases...',
  },
  labelSearchPets: {
    id: 'Search articles, news, breeds, animals...',
    defaultMessage: 'Search articles, news, breeds, animals...',
  },
  labelSearchTravel: {
    id: 'Search articles, news, places, tips...',
    defaultMessage: 'Search articles, news, places, tips...',
  },
  labelSearchFitness: {
    id: 'Search articles, news, sports...',
    defaultMessage: 'Search articles, news, sports...',
  },
  labelSearchAuto: {
    id: 'Search articles, news, cars, brands...',
    defaultMessage: 'Search articles, news, cars, brands...',
  },
  labelSearchGeneric: {
    id: 'Search articles, news, tips...',
    defaultMessage: 'Search articles, news, tips...',
  },
  allCategory: {
    id: 'All {category}',
    defaultMessage: 'All {category}',
  }
});
